import axiosInstance from '../axiosInstance'

// Models
import { Pagination, PaginationDto, paginationFromDto } from '../common/models/pagination'
import { Site, SiteJson } from '../sites/models/site'

export interface AuthSiteSearchForm {
    name?: string
}

interface AuthSiteSearchParams {
    name?: string
    per_page: number
    page: number
}


export const fetchSites = async (form: AuthSiteSearchForm, perPage: number, page: number): Promise<{ sites: Site[], pagination: Pagination }> => {
    const params: AuthSiteSearchParams = {
        per_page: perPage,
        page: page,
    }

    const name = form.name?.trim() ?? ''
    if (name.length > 0) {
        params.name = name
    }

    const response = await axiosInstance.get('api/orgs', { params })

    const data = response.data.data as SiteJson[]
    const meta = response.data.meta as { pagination: PaginationDto }

    return {
        sites: data.map((site) => {
            return Site.fromJson(site)
        }),
        pagination: paginationFromDto(meta.pagination)
    }
}